// PieChart.js
import React, { useMemo } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Box } from "@mui/material";

ChartJS.register(ArcElement, Tooltip, Legend);

const PieGraph = ({ data, width, height }) => {
  const chartData = useMemo(
    () => ({
      labels: data.labels,
      datasets: [
        {
          label: "# of Votes",
          data: data.values,
          backgroundColor: [
            "#2ECC71",
            "#F1948A",
            "#F4D03F",
            // "rgba(75, 192, 192, 0.2)",
            // "rgba(153, 102, 255, 0.2)",
            // "rgba(255, 159, 64, 0.2)",
          ],
          borderColor: [
            "#2ECC71",
            "#F1948A",
            "#F4D03F",
            // "rgba(75, 192, 192, 1)",
            // "rgba(153, 102, 255, 1)",
            // "rgba(255, 159, 64, 1)",
          ],
          borderWidth: 1,
        },
      ],
    }),
    [data]
  );
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Feedback Distribution",
      },
    },
    animation: {
      duration: 10, // Duration of 2 seconds
      easing: "easeInOutQuart", // Easing function for the animation
    },
  };
  return (
    <Box sx={{ width, height }}>
      <Pie data={chartData} options={options} />
    </Box>
  );
};

export default PieGraph;
